module.exports = __webpack_public_path__ + "img/banner.dd839dce.jpg";